import styled from 'styled-components';

export const ControlHelpText = styled.div`
  color: var(--color-secondary-text);
  font-style: italic;
  padding-bottom: 5px;
`;
